import { render, staticRenderFns } from "./authorities_list.vue?vue&type=template&id=7ac2f20b"
import script from "./authorities_list.vue?vue&type=script&lang=js"
export * from "./authorities_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports